import { useContext, useEffect } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { RootState } from "../../mp-core/redux/store"
import { getFilters } from "../components/FilterBar/helpers"
import { ReportingContext } from "../providers/ReportingProvider"
import { FiltersState } from "../states/filters"

export const useEmptyFiltersReset = (
  filters: FiltersState,
  onRemoveFilters: (filter: string[]) => void
) => {
  const location = useLocation()

  const { filtersByRoute } = useContext(ReportingContext)

  const user = useSelector((state: RootState) => state.users.testUser)

  useEffect(() => {
    if (!user?.role) return

    // Get filters for current view and role
    const filterKeys = getFilters(
      user.role,
      location.pathname,
      filtersByRoute
    ).map(filter => filter.key)

    // If there some extra filters that have no value setup, remove them.
    const filtersToRemove = Object.entries(filters)
      .filter(([key, value]) => !filterKeys.includes(key) && !value?.length)
      .map(filter => filter[0])

    onRemoveFilters(filtersToRemove)
  }, [user?.role, location.pathname])
}
